export enum PostalCodeRegex {
  CAN = '^[A-Za-z]\\d[A-Za-z][ -]?\\d[A-Za-z]\\d$',
  MEX = '\\d{5}',
  USA = "^([0-9]{5})(?:[-\\s]*([0-9]{4}))?$"
};
